"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createReservationsInfo;
function createReservationsInfo() {
    var fixture = init();

    function init() {
        return {};
    }

    return {
        setAvailability: function setAvailability(_ref) {
            var availability = _ref.availability;

            fixture.availability = availability;
            return this;
        },
        setFutureDelayMins: function setFutureDelayMins(_ref2) {
            var min = _ref2.min,
                max = _ref2.max;

            fixture.futureDelayMins = { min: min, max: max };
            return this;
        },
        val: function val() {
            return fixture;
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-restaurants-js-sdk/dist/fixtures/ReservationsInfo.js
// module id = 723
// module chunks = 0